import { render } from "./SummaryComponent.vue?vue&type=template&id=1b2e2442&scoped=true"
import script from "./SummaryComponent.vue?vue&type=script&lang=js"
export * from "./SummaryComponent.vue?vue&type=script&lang=js"

import "./SummaryComponent.vue?vue&type=style&index=0&id=1b2e2442&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2e2442"]])

export default __exports__